import React, { useEffect, useState } from 'react'
import { BrowserView, MobileView } from 'react-device-detect'
import ReviewSectionModal from '../../../Components/Modals/ReviewSectionModal'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Header from '../../../Components/Header';
import Footer from '../../../Components/Footer';
import { Link, useParams } from 'react-router-dom';
import { ApiService } from '../../../Components/Services/apiServices';
import Skeleton from 'react-loading-skeleton';
import { FaLocationArrow } from 'react-icons/fa';


const ListingDetail = () => {

    const { room_name } = useParams();
    const [userLocation, setUserLocation] = useState(null);
    const [propertydetails, setropertyDetails] = useState([]);
    const [review, setReview] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [visibleReviews, setVisibleReviews] = useState(3);
    const [hovered, setHovered] = useState(false);

    useEffect(() => {

        const fetchpropertyDetail = async () => {
            try {
                setLoading(true);
                const propertyDetailData = await ApiService.Commanfetchrequest(`properties/${room_name}`);
                setropertyDetails(propertyDetailData);
                console.log('property detail:', propertyDetailData);
            } catch (error) {
                console.log('error while fetching:', error);
            } finally {
                setLoading(false);
            }
        }

        const getUserLocation = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { latitude, longitude } = position.coords;
                        setUserLocation({ latitude, longitude });
                    },
                    (error) => {
                        console.error("Geolocation error:", error);
                    }
                );
            } else {
                console.warn("Geolocation not supported.");
            }
        };


        fetchpropertyDetail();
        getUserLocation();
    }, [room_name]);



    return (
        <>

            <BrowserView>
                <Header />

                {loading ? (
                    <>
                        <div className="container py-5">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div id="roomCarousel" className="carousel slide" data-bs-ride="carousel">
                                        <div className="carousel-inner">
                                            <Skeleton width={"100%"} height={300} />
                                        </div>
                                    </div>
                                    <div style={{
                                        background: '#fff',
                                        padding: '15px', borderRadius: '8px', marginBottom: '80px', marginTop: '10px'
                                    }}>
                                        {/* Rating Summary */}
                                        <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                                            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold' }}><Skeleton circle={true} width={40} height={40} /></h1>
                                            <p style={{ fontSize: '1.2rem', fontWeight: '600' }}>
                                                <Skeleton width={100} height={20} />
                                            </p>
                                            <p style={{ fontSize: '0.9rem', color: '#666' }}>
                                                <Skeleton width={400} height={30} />.
                                            </p>
                                        </div>
                                        {/* Review Tags */}
                                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '15px', gap: "10px" }}>
                                            {Array(4).fill().map((_, index) => (
                                                <Skeleton
                                                    key={index}
                                                    variant="rounded"
                                                    width={100}
                                                    height={32}
                                                    sx={{ borderRadius: '20px', margin: '5px' }}

                                                />
                                            ))}
                                        </div>
                                        {/* Swiper Slider for Reviews */}
                                        <Swiper
                                            spaceBetween={10}
                                            slidesPerView={2.5}
                                            style={{ paddingBottom: "15px" }}
                                            navigation

                                        >

                                            {Array(3).fill().map((_, index) => (
                                                <SwiperSlide key={index}>
                                                    <div
                                                        style={{
                                                            background: "#fff",
                                                            padding: "15px",
                                                            border: "1px solid #ddd",
                                                            borderRadius: "8px",
                                                            boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
                                                            marginBottom: "10px",
                                                        }}
                                                    >
                                                        <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                                            <Skeleton variant="circular" width={50} height={50} style={{ marginRight: "10px" }} />
                                                            <div style={{ flex: 1 }}>
                                                                <Skeleton width={100} height={20} />
                                                                <Skeleton width={60} height={15} />
                                                            </div>
                                                        </div>
                                                        <Skeleton width={120} height={20} style={{ marginBottom: 5 }} />
                                                        <Skeleton width="100%" height={40} />
                                                    </div>
                                                </SwiperSlide>
                                            ))}


                                        </Swiper>
                                        <div style={{ textAlign: 'center', marginTop: 10 }}>
                                            <button onClick={() => setShowModal(true)}
                                                style={{ width: '100%', }}>
                                                <Skeleton width="100%" height={40} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12 mt-4 mt-lg-0">
                                    <h2><Skeleton width={220} height={40} /></h2>
                                    <p className="text-muted"><Skeleton width={100} height={30} /></p>

                                    <div className="d-flex mb-3">
                                        <small className="border-end me-3 pe-3"><Skeleton width={70} height={20} /></small>
                                        <small className="border-end me-3 pe-3"><Skeleton width={70} height={20} /></small>
                                        <small><Skeleton width={70} height={20} /></small>
                                    </div>
                                    <p className="text-body mb-3">
                                        <Skeleton width={"100%"} height={240} />
                                    </p>

                                    <div className="d-flex gap-2">
                                        <Link to="#" className="btn btn-sm  rounded py-2 px-4 w-100 w-md-auto"><Skeleton width={"100%"} height={40} /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="container py-5">
                        <div className="row">
                            <div className="col-lg-6 col-md-12">
                                <div id="roomCarousel" className="carousel slide" data-bs-ride="carousel">
                                    <div className="carousel-inner">
                                        {propertydetails.room_images && propertydetails.room_images.map((image, index) => (
                                            <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={image.id}>
                                                <img src={`https://www.adminfamilyfun.jewelscraze.com/front/images/rooms/${image.room_images}`} className="d-block" alt={`Room ${index + 1}`} style={{ width: "100%", height: "300px" }} />
                                            </div>
                                        ))}
                                    </div>
                                    <button className="carousel-control-prev" type="button" data-bs-target="#roomCarousel" data-bs-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button className="carousel-control-next" type="button" data-bs-target="#roomCarousel" data-bs-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                </div>

                                <div style={{
                                    background: '#fff',
                                    padding: '15px', borderRadius: '8px', marginBottom: '80px', marginTop: '10px'
                                }}>
                                    {/* Rating Summary */}
                                    <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                                        <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>5.0</h1>
                                        <p style={{ fontSize: '1.2rem', fontWeight: '600' }}>
                                            Guest Favourite
                                        </p>
                                        <p style={{ fontSize: '0.9rem', color: '#666' }}>
                                            This Properties is a guest favourite based on ratings and reviews.
                                        </p>
                                    </div>
                                    {/* Review Tags */}
                                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '15px' }}>
                                        {['Great hospitality', 'Excellent support', 'Clean', 'Delicious food'].map((tag, index) => (
                                            <span key={index} style={{
                                                background: '#f8f9fa',
                                                padding: '8px 12px',
                                                borderRadius: '20px',
                                                fontSize: '0.85rem',
                                                margin: '5px'
                                            }}>
                                                {tag}
                                            </span>
                                        ))}
                                    </div>
                                    {/* Swiper Slider for Reviews */}
                                    <Swiper
                                        spaceBetween={10}
                                        slidesPerView={2.5}
                                        style={{ paddingBottom: "15px" }}
                                        navigation
                                        pagination={{ clickable: true }}
                                        modules={[Navigation, Pagination]}
                                    >

                                        <SwiperSlide>
                                            <div
                                                style={{
                                                    background: "#fff",
                                                    padding: "15px",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "8px",
                                                    boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                                    <img
                                                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSppkoKsaYMuIoNLDH7O8ePOacLPG1mKXtEng&s"
                                                        alt="User"
                                                        style={{
                                                            width: "50px",
                                                            height: "50px",
                                                            borderRadius: "50%",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    <div>
                                                        <strong>Sachin</strong>
                                                        <p style={{ fontSize: "0.8rem", color: "#666", margin: 0 }}>
                                                            2 days ago
                                                        </p>
                                                    </div>
                                                </div>
                                                <p style={{ fontSize: "0.9rem", fontWeight: "bold", marginBottom: "5px" }}>
                                                    {"★".repeat(5)} ({5} stars)
                                                </p>
                                                <p style={{ fontSize: "0.95rem", color: "#333", margin: 0 }}>
                                                    skgohrgoienrgjei9rgp
                                                </p>

                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide>
                                            <div
                                                style={{
                                                    background: "#fff",
                                                    padding: "15px",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "8px",
                                                    boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                                    <img
                                                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSppkoKsaYMuIoNLDH7O8ePOacLPG1mKXtEng&s"
                                                        alt="User"
                                                        style={{
                                                            width: "50px",
                                                            height: "50px",
                                                            borderRadius: "50%",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    <div>
                                                        <strong>Sachin</strong>
                                                        <p style={{ fontSize: "0.8rem", color: "#666", margin: 0 }}>
                                                            2 days ago
                                                        </p>
                                                    </div>
                                                </div>
                                                <p style={{ fontSize: "0.9rem", fontWeight: "bold", marginBottom: "5px" }}>
                                                    {"★".repeat(5)} ({5} stars)
                                                </p>
                                                <p style={{ fontSize: "0.95rem", color: "#333", margin: 0 }}>
                                                    skgohrgoienrgjei9rgp
                                                </p>

                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide>
                                            <div
                                                style={{
                                                    background: "#fff",
                                                    padding: "15px",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "8px",
                                                    boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                                    <img
                                                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSppkoKsaYMuIoNLDH7O8ePOacLPG1mKXtEng&s"
                                                        alt="User"
                                                        style={{
                                                            width: "50px",
                                                            height: "50px",
                                                            borderRadius: "50%",
                                                            marginRight: "10px",
                                                        }}
                                                    />
                                                    <div>
                                                        <strong>Sachin</strong>
                                                        <p style={{ fontSize: "0.8rem", color: "#666", margin: 0 }}>
                                                            2 days ago
                                                        </p>
                                                    </div>
                                                </div>
                                                <p style={{ fontSize: "0.9rem", fontWeight: "bold", marginBottom: "5px" }}>
                                                    {"★".repeat(5)} ({5} stars)
                                                </p>
                                                <p style={{ fontSize: "0.95rem", color: "#333", margin: 0 }}>
                                                    skgohrgoienrgjei9rgp
                                                </p>

                                            </div>
                                        </SwiperSlide>

                                    </Swiper>
                                    <div style={{ textAlign: 'center', marginTop: 10 }}>
                                        <button onClick={() => setShowModal(true)}
                                            style={{ width: '100%', padding: 10, background: 'transparent', border: '1px solid rgb(0, 0, 0)', borderRadius: 5, fontSize: '1rem', fontWeight: 600 }}>
                                            Show all 5 reviews
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-12 mt-4 mt-lg-0">
                                <h2>{propertydetails.room_name}</h2>
                                <a style={{ textDecoration: "none" }} href='#'><i className="fa fa-map-marker text-danger" /><span style={{ marginLeft: "12px" }}>{propertydetails.location}</span></a><br />
                                {userLocation && propertydetails.latitude && propertydetails.longitude ? (
                                    <a className='mt-3' style={{ textDecoration: "none", color: "black" }}
                                        href={`https://www.google.com/maps/dir/?api=1&origin=${userLocation.latitude},${userLocation.longitude}&destination=${propertydetails.latitude},${propertydetails.longitude}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaLocationArrow className="star-icon" style={{ color: "gray" }} />
                                        <span style={{ marginLeft: "12px", fontSize: "14px", fontWeight: "600", color: hovered ? 'blue' : '#000', transition: 'color 0.2s ease', }}
                                            onMouseEnter={() => setHovered(true)}
                                            onMouseLeave={() => setHovered(false)}
                                        >
                                            Get Direction
                                        </span>
                                    </a>
                                ) : (
                                    ""
                                )}
                                <p className="mb-3 mt-3">
                                    <i className="fa fa-star text-primary" />
                                    <i className="fa fa-star text-primary" />
                                    <i className="fa fa-star text-primary" />
                                    <i className="fa fa-star text-primary" />
                                    <i className="fa fa-star-half text-primary" />
                                </p>

                                {/* <div className="d-flex mb-3">
                                <small className="border-end me-3 pe-3"><i className="fa fa-bed text-primary me-2" /> 3 Bed</small>
                                <small className="border-end me-3 pe-3"><i className="fa fa-bath text-primary me-2" /> 2 Bath</small>
                                <small><i className="fa fa-wifi text-primary me-2" /> Wifi</small>
                            </div> */}
                                <p className="text-body mb-3" dangerouslySetInnerHTML={{ __html: propertydetails.description }} />

                                <p className="text-body mb-3">
                                    <span style={{ fontSize: "16px", fontWeight: "600" }}>About Space :-</span><br />
                                    <span dangerouslySetInnerHTML={{ __html: propertydetails.about_space }}></span>
                                </p>

                                <p className="text-body mb-3">
                                    <span style={{ fontSize: "16px", fontWeight: "600" }}>Guest Access :-</span><br />
                                    <span dangerouslySetInnerHTML={{ __html: propertydetails.guest_access }}></span>
                                </p>

                                <p className="text-body mb-3">
                                    <span style={{ fontSize: "16px", fontWeight: "600" }}>Other Things to Note Down :-</span><br />
                                    <span dangerouslySetInnerHTML={{ __html: propertydetails.guest_access }}></span>

                                </p>

                                <div className="d-flex gap-2">
                                    <Link to="/" className="btn btn-sm btn-primary rounded py-2 px-4 w-100 w-md-auto">Back to Home</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                )}


                <Footer />
            </BrowserView>

            <MobileView>
                <Header />

                {loading ? (
                    <>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div id="roomCarousel" className="carousel slide" data-bs-ride="carousel">
                                        <div className="carousel-inner">
                                            <div className="carousel-inner">

                                                <Skeleton width={"100%"} height={280} />

                                            </div>
                                        </div>
                                        <button className="carousel-control-prev" type="button" data-bs-target="#roomCarousel" data-bs-slide="prev">
                                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                            <span className="visually-hidden">Previous</span>
                                        </button>
                                        <button className="carousel-control-next" type="button" data-bs-target="#roomCarousel" data-bs-slide="next">
                                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                            <span className="visually-hidden">Next</span>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12 mt-4 mt-lg-0">
                                    <h2><Skeleton width={220} height={40} /></h2>
                                    <a className='mt-2' style={{ textDecoration: "none" }} href='#'>

                                        <Skeleton width={100} height={30} />
                                    </a>
                                    <p className="mb-3 mt-2">
                                        <Skeleton width={100} height={30} />
                                    </p>

                                    {/* <div className="d-flex mb-3">
                                <small className="border-end me-3 pe-3"><i className="fa fa-bed text-primary me-2" /> 3 Bed</small>
                                <small className="border-end me-3 pe-3"><i className="fa fa-bath text-primary me-2" /> 2 Bath</small>
                                <small><i className="fa fa-wifi text-primary me-2" /> Wifi</small>
                            </div> */}
                                    <p className="text-body mb-3">
                                        <Skeleton width={"100%"} height={140} />
                                    </p>

                                    <div style={{
                                        background: '#fff',
                                        padding: '15px', borderRadius: '8px', marginBottom: '80px', marginTop: '10px'
                                    }}>
                                        {/* Rating Summary */}
                                        <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                                            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>
                                                <Skeleton circle={true} width={40} height={40} />
                                            </h1>
                                            <p style={{ fontSize: '1.2rem', fontWeight: '600' }}>
                                                <Skeleton width={100} height={40} />
                                            </p>
                                            <p style={{ fontSize: '0.9rem', color: '#666' }}>
                                                <Skeleton width={300} height={40} />
                                            </p>
                                        </div>
                                        {/* Review Tags */}
                                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '15px', gap: "10px" }}>
                                            {Array(4).fill().map((_, index) => (
                                                <Skeleton
                                                    key={index}
                                                    variant="rounded"
                                                    width={100}
                                                    height={32}
                                                    sx={{ borderRadius: '20px', margin: '5px' }}
                                                />
                                            ))}
                                        </div>
                                        {/* Swiper Slider for Reviews */}
                                        <Swiper
                                            spaceBetween={10}
                                            slidesPerView={1.5}
                                            style={{ paddingBottom: "15px" }}
                                            navigation

                                        >
                                            {Array(3).fill().map((_, index) => (
                                                <SwiperSlide key={index}>
                                                    <div
                                                        style={{
                                                            background: "#fff",
                                                            padding: "15px",
                                                            border: "1px solid #ddd",
                                                            borderRadius: "8px",
                                                            boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
                                                            marginBottom: "10px",
                                                        }}
                                                    >
                                                        <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                                            <Skeleton variant="circular" width={50} height={50} style={{ marginRight: "10px" }} />
                                                            <div style={{ flex: 1 }}>
                                                                <Skeleton width={100} height={20} />
                                                                <Skeleton width={60} height={15} />
                                                            </div>
                                                        </div>
                                                        <Skeleton width={120} height={20} style={{ marginBottom: 5 }} />
                                                        <Skeleton width="100%" height={40} />
                                                    </div>
                                                </SwiperSlide>
                                            ))}

                                        </Swiper>
                                        <div style={{ textAlign: 'center', marginTop: 10 }}>
                                            <button onClick={() => setShowModal(true)}
                                                style={{ width: '100%' }}>
                                                <Skeleton width="100%" height={40} />
                                            </button>
                                        </div>
                                    </div>

                                    <div className="d-flex gap-2">
                                        <Link to="/" className="btn btn-sm  rounded py-2 px-4 w-100 w-md-auto"><Skeleton width="100%" height={40} /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div id="roomCarousel" className="carousel slide" data-bs-ride="carousel">
                                        <div className="carousel-inner">
                                            <div className="carousel-inner">
                                                {propertydetails.room_images && propertydetails.room_images.map((image, index) => (
                                                    <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={image.id}>
                                                        <img src={`https://www.adminfamilyfun.jewelscraze.com/front/images/rooms/${image.room_images}`} className="d-block w-100" alt={`Room ${index + 1}`} />
                                                    </div>
                                                ))}

                                            </div>
                                        </div>
                                        <button className="carousel-control-prev" type="button" data-bs-target="#roomCarousel" data-bs-slide="prev">
                                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                            <span className="visually-hidden">Previous</span>
                                        </button>
                                        <button className="carousel-control-next" type="button" data-bs-target="#roomCarousel" data-bs-slide="next">
                                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                            <span className="visually-hidden">Next</span>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12 mt-4 mt-lg-0">
                                    <h2>{propertydetails.room_name}</h2>
                                    <a className='mt-2' style={{ textDecoration: "none" }} href='#'><i className="fa fa-map-marker text-danger" /><span style={{ marginLeft: "12px" }}>{propertydetails.location}</span></a><br/>
                                    {userLocation && propertydetails.latitude && propertydetails.longitude ? (
                                        <a className='mt-3' style={{ textDecoration: "none", color: "black" }}
                                            href={`https://www.google.com/maps/dir/?api=1&origin=${userLocation.latitude},${userLocation.longitude}&destination=${propertydetails.latitude},${propertydetails.longitude}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <FaLocationArrow className="star-icon" style={{ color: "gray" }} />
                                            <span style={{ marginLeft: "12px", fontSize: "14px", fontWeight: "600", color: hovered ? 'blue' : '#000', transition: 'color 0.2s ease', }}
                                                onMouseEnter={() => setHovered(true)}
                                                onMouseLeave={() => setHovered(false)}
                                            >
                                                Get Direction
                                            </span>
                                        </a>
                                    ) : (
                                        ""
                                    )}
                                    <p className="mb-3 mt-2">
                                        <i className="fa fa-star text-primary" />
                                        <i className="fa fa-star text-primary" />
                                        <i className="fa fa-star text-primary" />
                                        <i className="fa fa-star text-primary" />
                                        <i className="fa fa-star-half text-primary" />
                                    </p>

                                    {/* <div className="d-flex mb-3">
                                <small className="border-end me-3 pe-3"><i className="fa fa-bed text-primary me-2" /> 3 Bed</small>
                                <small className="border-end me-3 pe-3"><i className="fa fa-bath text-primary me-2" /> 2 Bath</small>
                                <small><i className="fa fa-wifi text-primary me-2" /> Wifi</small>
                            </div> */}
                                    <p className="text-body mb-3" dangerouslySetInnerHTML={{ __html: propertydetails.description }}>
                                    </p>



                                    <p className="text-body mb-3">
                                        <span style={{ fontSize: "16px", fontWeight: "600" }}>About Space :-</span><br />
                                        <span dangerouslySetInnerHTML={{ __html: propertydetails.about_space }}></span>
                                    </p>

                                    <p className="text-body mb-3">
                                        <span style={{ fontSize: "16px", fontWeight: "600" }}>Guest Access :-</span><br />
                                        <span dangerouslySetInnerHTML={{ __html: propertydetails.guest_access }}></span>
                                    </p>

                                    <p className="text-body mb-3">
                                        <span style={{ fontSize: "16px", fontWeight: "600" }}>Other Things to Note Down :-</span><br />
                                        <span dangerouslySetInnerHTML={{ __html: propertydetails.guest_access }}></span>

                                    </p>

                                    <div style={{
                                        background: '#fff',
                                        padding: '15px', borderRadius: '8px', marginBottom: '80px', marginTop: '10px'
                                    }}>
                                        {/* Rating Summary */}
                                        <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                                            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>5.0</h1>
                                            <p style={{ fontSize: '1.2rem', fontWeight: '600' }}>
                                                Guest Favourite
                                            </p>
                                            <p style={{ fontSize: '0.9rem', color: '#666' }}>
                                                This properties is a guest favourite based on ratings and reviews.
                                            </p>
                                        </div>
                                        {/* Review Tags */}
                                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '15px' }}>
                                            {['Great hospitality', 'Excellent support', 'Clean', 'Awesome'].map((tag, index) => (
                                                <span key={index} style={{
                                                    background: '#f8f9fa',
                                                    padding: '8px 12px',
                                                    borderRadius: '20px',
                                                    fontSize: '0.85rem',
                                                    margin: '5px'
                                                }}>
                                                    {tag}
                                                </span>
                                            ))}
                                        </div>
                                        {/* Swiper Slider for Reviews */}
                                        <Swiper
                                            spaceBetween={10}
                                            slidesPerView={1.5}
                                            style={{ paddingBottom: "15px" }}
                                            navigation
                                            pagination={{ clickable: true }}
                                            modules={[Navigation, Pagination]}
                                        >

                                            <SwiperSlide>
                                                <div
                                                    style={{
                                                        background: "#fff",
                                                        padding: "15px",
                                                        border: "1px solid #ddd",
                                                        borderRadius: "8px",
                                                        boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                                        <img
                                                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSppkoKsaYMuIoNLDH7O8ePOacLPG1mKXtEng&s"
                                                            alt="User"
                                                            style={{
                                                                width: "50px",
                                                                height: "50px",
                                                                borderRadius: "50%",
                                                                marginRight: "10px",
                                                            }}
                                                        />
                                                        <div>
                                                            <strong>Sachin</strong>
                                                            <p style={{ fontSize: "0.8rem", color: "#666", margin: 0 }}>
                                                                2 days ago
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <p style={{ fontSize: "0.9rem", fontWeight: "bold", marginBottom: "5px" }}>
                                                        {"★".repeat(5)} ({5} stars)
                                                    </p>
                                                    <p style={{ fontSize: "0.95rem", color: "#333", margin: 0 }}>
                                                        skgohrgoienrgjei9rgp
                                                    </p>

                                                </div>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <div
                                                    style={{
                                                        background: "#fff",
                                                        padding: "15px",
                                                        border: "1px solid #ddd",
                                                        borderRadius: "8px",
                                                        boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                                        <img
                                                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSppkoKsaYMuIoNLDH7O8ePOacLPG1mKXtEng&s"
                                                            alt="User"
                                                            style={{
                                                                width: "50px",
                                                                height: "50px",
                                                                borderRadius: "50%",
                                                                marginRight: "10px",
                                                            }}
                                                        />
                                                        <div>
                                                            <strong>Sachin</strong>
                                                            <p style={{ fontSize: "0.8rem", color: "#666", margin: 0 }}>
                                                                2 days ago
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <p style={{ fontSize: "0.9rem", fontWeight: "bold", marginBottom: "5px" }}>
                                                        {"★".repeat(5)} ({5} stars)
                                                    </p>
                                                    <p style={{ fontSize: "0.95rem", color: "#333", margin: 0 }}>
                                                        skgohrgoienrgjei9rgp
                                                    </p>

                                                </div>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <div
                                                    style={{
                                                        background: "#fff",
                                                        padding: "15px",
                                                        border: "1px solid #ddd",
                                                        borderRadius: "8px",
                                                        boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                                        <img
                                                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSppkoKsaYMuIoNLDH7O8ePOacLPG1mKXtEng&s"
                                                            alt="User"
                                                            style={{
                                                                width: "50px",
                                                                height: "50px",
                                                                borderRadius: "50%",
                                                                marginRight: "10px",
                                                            }}
                                                        />
                                                        <div>
                                                            <strong>Sachin</strong>
                                                            <p style={{ fontSize: "0.8rem", color: "#666", margin: 0 }}>
                                                                2 days ago
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <p style={{ fontSize: "0.9rem", fontWeight: "bold", marginBottom: "5px" }}>
                                                        {"★".repeat(5)} ({5} stars)
                                                    </p>
                                                    <p style={{ fontSize: "0.95rem", color: "#333", margin: 0 }}>
                                                        skgohrgoienrgjei9rgp
                                                    </p>

                                                </div>
                                            </SwiperSlide>

                                        </Swiper>
                                        <div style={{ textAlign: 'center', marginTop: 10 }}>
                                            <button onClick={() => setShowModal(true)}
                                                style={{ width: '100%', padding: 10, background: 'transparent', border: '1px solid rgb(0, 0, 0)', borderRadius: 5, fontSize: '1rem', fontWeight: 600 }}>
                                                Show all 5 reviews
                                            </button>
                                        </div>
                                    </div>

                                    <div className="d-flex gap-2">
                                        <Link to="/" className="btn btn-sm btn-primary rounded py-2 px-4 w-100 w-md-auto">Back to Home</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                <Footer />
            </MobileView>


            <ReviewSectionModal show={showModal} onClose={() => setShowModal(false)} />

        </>
    )
}

export default ListingDetail
